'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _breakPointMediator = require('../../../utils/breakpoint/breakPointMediator');

var _breakPointMediator2 = _interopRequireDefault(_breakPointMediator);

var _BreakPointIndicator = require('./BreakPointIndicator.scss');

var _BreakPointIndicator2 = _interopRequireDefault(_BreakPointIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * BreakPoints helper
 * @access public
 * @extends {React.Component}
 */
var BKPIndicator = function (_React$Component) {
  (0, _inherits3.default)(BKPIndicator, _React$Component);

  function BKPIndicator() {
    (0, _classCallCheck3.default)(this, BKPIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (BKPIndicator.__proto__ || (0, _getPrototypeOf2.default)(BKPIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(BKPIndicator, [{
    key: 'componentDidMount',

    /**
     * Get breakpoint value from component DOM
     */
    value: function componentDidMount() {
      _breakPointMediator2.default.value = window.getComputedStyle(this.node, ':before').getPropertyValue('content').replace(/"/g, '');
    }

    /**
     * Div helper to include breakpoint value using media queries
     * using local styles
     * @returns {JSX}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', { className: "indicator-ad", ref: function ref(node) {
          _this2.node = node;
        } });
    }
  }]);
  return BKPIndicator;
}(_react2.default.Component);

exports.default = BKPIndicator;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/components/breakpoint/BreakPointIndicator/index.js
// module id = 155
// module chunks = 35783957827783